import { UserPlus, TrendingUp, MessagesSquare, Zap } from "lucide-react";
import Reveal from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    icon: UserPlus,
    title: "Daftar & Konfirmasi",
    desc: "Daftar melalui link resmi dan konfirmasi akun yang memenuhi syarat.",
  },
  {
    num: "02",
    icon: TrendingUp,
    title: "Trading & Kumpulkan Lot",
    desc: "Lakukan trading sesuai rencana dan kumpulkan lot yang memenuhi ketentuan.",
  },
  {
    num: "03",
    icon: MessagesSquare,
    title: "Klaim via Admin",
    desc: "Hubungi admin untuk informasi rebate dan penukaran hadiah.",
  },
];

export default function HowItWorks() {
  return (
    <section id="cara-kerja" className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-[#00F2B6] sm:text-sm">
            Cara Kerja
          </p>
          <h2 className="mt-3 font-display text-3xl font-black uppercase tracking-tight text-white sm:text-5xl">
            Tiga Langkah, <span className="text-gradient-gold">Langsung Jalan</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:mt-16 md:grid-cols-3">
          {STEPS.map((step, i) => (
            <Reveal
              key={step.num}
              delay={i * 0.12}
              testId={`cara-kerja-step-${step.num}`}
            >
              <article className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-[#0D111A] p-7 transition-all duration-300 hover:border-[#F0B429]/50 hover:shadow-[0_0_40px_rgba(240,180,41,0.15)] sm:p-8">
                <div className="pointer-events-none absolute -right-6 -top-8 font-display text-[7rem] font-black leading-none text-white/[0.04] transition-colors duration-300 group-hover:text-[#F0B429]/10">
                  {step.num}
                </div>
                <div className="glass flex h-12 w-12 items-center justify-center rounded-2xl">
                  <step.icon className="h-5 w-5 text-[#00F2B6]" />
                </div>
                <p className="mt-6 font-mono text-xs font-bold tracking-[0.25em] text-[#F0B429]">
                  Langkah {step.num}
                </p>
                <h3 className="mt-2 text-lg font-bold text-white sm:text-xl">
                  {step.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-zinc-400">
                  {step.desc}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-8">
          <div className="glass flex flex-col items-center gap-3 rounded-3xl px-6 py-5 text-center sm:flex-row sm:justify-center sm:gap-4 sm:text-left">
            <span className="glass flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
              <Zap className="h-5 w-5 text-[#00F2B6]" />
            </span>
            <p className="text-sm text-zinc-300 sm:text-base">
              Setiap lot yang memenuhi syarat mendapat rebate{" "}
              <span className="font-bold text-[#00F2B6]">US$15</span>. Detail
              ketentuan? Tanya langsung ke admin.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
